// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container_request[data-v-2a7f6c2c]{display:flex;justify-content:center;align-items:center;height:calc(100vh - 30%)}", ""]);
// Exports
module.exports = exports;
